import { createContext, useContext } from "react";
import { Active } from "@dnd-kit/core";
import { DragAndDropScopeConfiguration } from "utilities/contexts/shared-drag-and-drop/drag-and-drop-scope-configuration";

export type RegisterDragAndDropScope = (
    scopeName: string,
    configuration: DragAndDropScopeConfiguration
) => UnregisterDragAndDropScope;
export type UnregisterDragAndDropScope = () => void;

export interface DragAndDropScopeRegistryContext {
    getScopeConfigurationByDraggable: (
        draggable: Active
    ) => DragAndDropScopeConfiguration | undefined;
    registerDragAndDropScope: RegisterDragAndDropScope;
}

const defaultDragAndDropScopeRegistryContext: DragAndDropScopeRegistryContext =
    {
        getScopeConfigurationByDraggable: () => undefined,
        registerDragAndDropScope: () => () => {},
    };

export const DragAndDropScopeRegistryReactContext =
    createContext<DragAndDropScopeRegistryContext>(
        defaultDragAndDropScopeRegistryContext
    );

export const useRegisterDragAndDropScopeContext = () =>
    useContext(DragAndDropScopeRegistryReactContext);
